/**
 * Copyright (C) Siemens AG 1996-2024 ALL RIGHTS RESERVED.
 */

import {Component, EventEmitter, Input, Output, inject} from '@angular/core';
import {UserService} from '../../../services/user.service';
import {ToastService} from '@siemens/ix-angular';
import {TranslateService} from '@ngx-translate/core';
import {User} from '../../../models/User';

@Component({
  selector: 'app-user-settings',
  templateUrl: './user-settings.component.html',
  styleUrl: './user-settings.component.scss',
  standalone: false,
})
export class UserSettingsComponent {
  private readonly userService = inject(UserService);
  private readonly toastService = inject(ToastService);
  private readonly translate = inject(TranslateService);

  @Input() userData!: User;
  @Output() userDataChange = new EventEmitter<boolean>();

  loading = false;

  async updateUser(userData: User) {
    this.loading = true;
    this.userService.changeLanguage(userData.language);
    const msg = await this.translate.instant('settings.user_changed');
    await this.toastService.show({message: msg, type: 'success'});
    this.userDataChange.emit(true);
    this.loading = false;
  }
}
